import React from 'react';
import { AnyObject } from '@triare/auth-redux';

export interface ContextMode {
  mode?: 'edit' | 'create'
}

export interface IdOnly {
  id: string
}

export interface Option extends AnyObject {
  value: string | boolean | number;
  label: string | React.ReactNode;
  disabled?: boolean;
}

export interface SimpleOption {
  value: string;
  label: string;
}

export interface ModalState {
  type: ModalTypes;
  id?: number;
}

export enum ModalTypes {
  'create' = 'create',
  'update' = 'update',
  'delete' = 'delete',
}

export interface SimpleProviderProps {
  children: React.ReactNode
}

export enum YesNoEnum {
  yes = 'Yes',
  no = 'No',
}
